import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import engerPark from '../resources/enger-park.JPEG';

function Join() {
  return (
		<>
			<Meta title='Join Us' />
			<Header />
			<div class='main-content'>
				<h2>Join Us</h2>
				<p>
					<h4>To join Borealis Blades Historical Fencing:</h4>
				</p>
				<ul>
					<li>
						Join our <a href="https://www.facebook.com/groups/663748787168716/">Facebook group</a> to get updates on when and where we will be practicing next.
					</li>
					<li>
						Beginners can come to any practice and will be asked to sign a standard HEMA Alliance (HEMAA) waiver. 
						This waiver can be seen <a href='/resources'>here</a>. 
					</li>
					<li>
						After 2 months, <a href='https://www.hemaalliance.com/memberships'>become a member of the HEMAA</a> which has an annual cost of $30. 
					</li>	
					<li>
						Participant must be at least 18 years old, or 16 with parental consent.
					</li>
				</ul>
				<br />
				<p>
					BBHF strives to be accessible to all people. There is no charge for the first two months that you practice with us. 
					Gear will also be provided to new members. This allows people a chance to see if HEMA is for them without 
					having to make any financial investment. After the first two free months, 
					you will have to become a full-on member of the <a href='https://www.hemaalliance.com/memberships'>HEMAA</a> (our parent organization). 
					The cost to join the HEMAA is currently $30 a year for an individual membership.
					<br /><br />
					<div class='img-right' style={{maxWidth: '40%'}}>
						<img class='main-img' src={engerPark} />
					</div>
					Feel free to join our <a href="https://www.facebook.com/groups/663748787168716/">Facebook group</a> and ask to join Discord to chat with other members on either platform. 
					We strongly encourage new members to utilize the club gear at first and avoid purchasing any items or gear before joining us at a practice. 
					This can help new people avoid buying gear that's not compatible with what we use or potentially unsafe equipment. 
					The other major benefit to using club gear is that you get to try before you buy and make sure you get the right size gear when you do purchase. 
					Many of the larger <a href='/resources'>HEMA vendors</a> offer discounts to HEMAA members, 
					so waiting to purchase gear until you're a full-on member of the HEMAA can lead to real cost savings in the long run.
					<br /><br />
				</p>
				<h4>Have more questions?</h4>
				<p>
					If you have any questions that we don’t cover here or on our <a href='/FAQ'>FAQ page</a>, 
					please reach out to our <a href="https://www.facebook.com/groups/663748787168716/">Facebook group</a> or <a href='mailto:borealisblades@gmail.com'>email</a>.
				</p>
				<br />
				<h3>Guest Fencers</h3>
					<h4>Visiting the North Shore?</h4>
				<p>
					Borealis Blades welcomes anyone who happens to be traveling through the area to join us for practice. 
					<br /><br />
					If you want to keep up with training while you are away from home, please reach out to us on our <a href="https://www.facebook.com/groups/663748787168716/">Facebook group</a> or 
					via <a href='mailto:borealisblades@gmail.com'>email</a> to find that week's location and time of practice so you can join us. 
					If you're traveling light, you will be able to use club gear to join in our practice. 
					Simply sign our normal <a href='/resources'>club waiver</a> at the start of practice and wear what you would for any other type of gym workout.
					<br /><br />
					We look forward to having you!
				</p>
			</div>
			<Footer />  
		</>
	);
};

export default Join;
